/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
// List of notification permissions
export const NOTIFICATIONS_PERMISSIONS = {
  GRANTED: 'granted',
  DENIED: 'denied',
  DEFAULT: 'default'
};
